
const fakeAuth = {
  isAuthenticated: sessionStorage.getItem('token') !== null ? true : false,
  authenticate(cb) {
    this.isAuthenticated = true
    setTimeout(cb, 100)
  },

  signout(cb) {
    this.isAuthenticated = false
    setTimeout(cb, 100)
  },

  inactivityTime() {
    let timer;

    window.onload = resetTimer;
    document.onmousemove = resetTimer;
    document.onmousedown = resetTimer;
    document.onkeydown = resetTimer;  
    document.onkeyup = resetTimer; 

    function logout() {
      alert("Tu sesión fue cerrada por tiempo de inactividad.");        
      sessionStorage.clear();
      window.location.reload();                       
      //location.href = 'logout.html'
    }

    function resetTimer() {         
      clearTimeout(timer);      
      timer = setTimeout(logout,3600000);
      
    }
  }
}

export default fakeAuth;